import { useCallback, useState } from 'react';

export interface UseAritoDialogParams {
  initialOpen?: boolean;
  initialFullScreen?: boolean;
  onFullscreenToggle?: () => void;
}

export interface UseAritoDialogReturn {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  isFullScreen: boolean;
  setIsFullScreen: (isFullScreen: boolean) => void;
  toggleFullScreen: () => void;
  open: () => void;
  close: () => void;
}

export const useAritoDialog = ({
  initialOpen = false,
  initialFullScreen = false,
  onFullscreenToggle
}: UseAritoDialogParams = {}): UseAritoDialogReturn => {
  const [isOpen, setIsOpen] = useState(initialOpen);
  const [isFullScreen, setIsFullScreen] = useState(initialFullScreen);

  const open = useCallback(() => {
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const toggleFullScreen = useCallback(() => {
    const newFullScreenState = !isFullScreen;
    setIsFullScreen(newFullScreenState);
    onFullscreenToggle?.();
  }, [isFullScreen, onFullscreenToggle]);

  return {
    isOpen,
    setIsOpen,
    isFullScreen,
    setIsFullScreen,
    toggleFullScreen,
    open,
    close
  };
};

export default useAritoDialog;
